import Alert from '@mui/material/Alert';
import Link from '@mui/material/Link';
import { useTranslation } from '@tyro/i18n';

interface ReaderBrokenLinkAlertProps {
  broken: number;
  pending: number;
  onOpenInEditor?: () => void;
}

export function ReaderBrokenLinkAlert({
  broken,
  pending,
  onOpenInEditor,
}: ReaderBrokenLinkAlertProps) {
  const { t } = useTranslation(['documentation']);
  const summary = (() => {
    if (broken > 0 && pending > 0) {
      return t('documentation:reader.brokenLink.alertSummary.both', {
        broken,
        pending,
      });
    }
    if (broken > 0) {
      return t('documentation:reader.brokenLink.alertSummary.brokenOnly', {
        count: broken,
      });
    }
    return t('documentation:reader.brokenLink.alertSummary.pendingOnly', {
      count: pending,
    });
  })();
  return (
    <Alert
      severity="warning"
      variant="outlined"
      sx={{ mb: 2, '.MuiAlert-action': { alignItems: 'center' } }}
      action={
        onOpenInEditor ? (
          <Link
            component="button"
            type="button"
            variant="body2"
            underline="hover"
            color="inherit"
            onClick={onOpenInEditor}
          >
            {t('documentation:reader.brokenLink.openEditor')}
          </Link>
        ) : null
      }
    >
      {summary}
    </Alert>
  );
}
